export default __webpack_public_path__ + "static/retirement-planning-7-7a8ac878623f8044be3c6cdbf42d26b4.png";